<div class="container">
  <div class="offset-1 col-10">

    <div class=" card card-chart">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-sm-6 text-left">
            <h5 class=" card-category">Investment Solution</h5>
            <h2 class=" card-title"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement the Investable Portfolio</h2>
          </div>
        </div>
      </div>
      <div class=" card-body text-center">

        <div class="row mt-3">
          <div class="offset-3 col-3 text-right" style="line-height: 48px; color: grey">
            Quarterly rebalancing
          </div>
          <mat-form-field>
            <mat-select [(value)]="investableParameters.quarterly_rebalancing">
              <mat-option value="automatic">Automatic</mat-option>
              <mat-option value="manual">Manual</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <br>
        <p>At every moment, you will be able to come back, modify parameters, or launch optimizations.</p>
        <p>Save your work and run a detailed analysis of the portfolio.</p>
      </div>

      <div class=" card-footer">
        <div class="row text-center">
          <div class="col-6">
            <app-button [disabled]="isComputing" (click)="implementAndGoToAnalytics()">Save & Show Analytics</app-button>
          </div>
          <div class="col-6">
            <app-button [disabled]="isComputing" (click)="implementAndProtectPortfolio()">Protect Portfolio</app-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
